const toAttributeString = (value) => {
    if (value == null) return ''
    if (Array.isArray(value)) return value.filter(Boolean).join(',')
    return String(value)
}

const getSourceProduct = (product) => product?.representedProduct ?? product

export const getMarketingProductAttributes = (product) => {
    const source = getSourceProduct(product)

    return {
        c_gender: toAttributeString(source?.c_gender),
        c_style: toAttributeString(source?.c_style),
        c_activities: toAttributeString(source?.c_activities)
    }
}

export const emptyMarketingProductAttributes = {
    c_gender: '',
    c_style: '',
    c_activities: ''
}
